import { findCountryByAlpha3Code } from '@src/common/auth';
import type { Alpha3Code } from '@src/domains/customers/types/auth';

export interface CountryDisplay {
  /** ISO 3166-1 alpha-2 — what a flag component expects. */
  alpha2: string;
  emoji: string;
  /** English name from the country list; a locale-aware label is the feature's job. */
  fallbackName: string;
}

export function resolveCountryDisplay(countryCode: Alpha3Code | null | undefined): CountryDisplay | null {
  if (!countryCode) {
    return null;
  }

  const country = findCountryByAlpha3Code(countryCode);

  if (!country) {
    return null;
  }

  return { alpha2: country.alpha2, emoji: country.emoji, fallbackName: country.name };
}
